import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Icon, Message, MessageContent } from 'semantic-ui-react'
import './Toast.scss'

function Toast(props) {
  const { message, count = 1, onClose } = props
  const type = props.type.toLowerCase()
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 5000) // Automatically close the toast after 5 seconds

    return () => clearTimeout(timer)
  }, [onClose])

  const isNegative = type === 'negative' || type === 'error'
  const isPositive = type === 'positive' || type === 'success'
  const hasIcon = () => isNegative || isPositive

  return (
    <div className={`toast ${type}`}>
      <Message className={type} floating>
        {hasIcon() && (
          <Icon
            name={isNegative ? 'exclamation circle' : 'check circle'}
            className='front-icon'
          />
        )}
        <MessageContent title={message}>
          {message}
          {/* Repeats are collapsed into one toast rather than queued, so the
              count is the only signal that this happened more than once. */}
          {count > 1 && (
            <span className='repeat-count' data-testid='toast-repeat-count'>
              ×{count}
            </span>
          )}
        </MessageContent>
        <Icon name='close' onClick={onClose} />
      </Message>
    </div>
  )
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  count: PropTypes.number,
  type: PropTypes.oneOf([
    'negative',
    'error',
    'positive',
    'success',
    'info',
    'warning',
    'Negative',
    'Error',
    'Positive',
    'Success',
    'Info',
    'Warning',
  ]),
  onClose: PropTypes.func,
}

export default Toast
